export default "__VITE_ASSET___TC_5tGN__"